// components/panelCompra/DatosComprador.tsx
"use client";
import { useFormContext } from "react-hook-form";
import { type CheckoutPayload, type TipoDocumento } from "@/schemas/checkout.schema";

type Props = {
  onClick?: () => void;
}

const DOC_PLACEHOLDERS: Record<TipoDocumento, string> = {
  dni: "Ej: 12345678",
  cuit: "Ej: 20123456789",
  pasaporte: "Ej: AAB123456",
};

export function DatosComprador({ onClick }: Props) {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<CheckoutPayload>();

  const tipoDocumento = watch("comprador.tipoDocumento");
  const docPlaceholder = DOC_PLACEHOLDERS[tipoDocumento as TipoDocumento] ?? "Documento";

  return (<>

    <section className="space-y-4 text-white">
       {/* Nombre */}
  <div>
    <input
      {...register("comprador.nombre")}
      placeholder="Nombre y Apellido"
      className="w-full bg-black/30 border border-white/70 rounded-md px-3 py-2 text-white placeholder-white/80 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-white/90"
    />
    {errors.comprador?.nombre?.message && (
      <p className="text-red-300 text-sm mt-1">
        {errors.comprador.nombre.message}
      </p>
    )}
  </div>

  {/* Email */}
  <div>
    <input
      {...register("comprador.email")}
      type="email"
      placeholder="Email"
      className="w-full bg-black/30 border border-white/70 rounded-md px-3 py-2 text-white placeholder-white/80 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-white/90"
    />
    {errors.comprador?.email?.message && (
      <p className="text-red-300 text-sm mt-1">
        {errors.comprador.email.message}
      </p>
    )}
  </div>

  {/* Teléfono */}
  <div>
    <input
      {...register("comprador.telefono")}
      placeholder="Teléfono"
      className="w-full bg-black/30 border border-white/70 rounded-md px-3 py-2 text-white placeholder-white/80 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-white/90"
    />
    {errors.comprador?.telefono?.message && (
      <p className="text-red-300 text-sm mt-1">
        {errors.comprador.telefono.message}
      </p>
    )}
  </div>

  {/* Tipo de Documento */}
  <div>
    <select
      {...register("comprador.tipoDocumento")}
      className="w-full bg-black/30 border border-white/70 rounded-md px-2 py-2 text-white text-sm focus:outline-none focus:ring-2 focus:ring-white/90 cursor-pointer"
    >
      <option value="" className="bg-gray-800 text-white/40">Tipo de documento</option>
      <option value="dni" className="bg-gray-800 text-white">DNI</option>
      <option value="cuit" className="bg-gray-800 text-white">CUIT</option>
      <option value="pasaporte" className="bg-gray-800 text-white">Pasaporte</option>
    </select>
    {errors.comprador?.tipoDocumento?.message && (
      <p className="text-red-300 text-sm mt-1">
        {errors.comprador.tipoDocumento.message}
      </p>
    )}
  </div>

  {/* Documento */}
  <div>
    <input
      {...register("comprador.doc")}
      placeholder={docPlaceholder}
      className="w-full bg-black/30 border border-white/70 rounded-md px-3 py-2 text-white placeholder-white/80 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-white/90"
    />
    {errors.comprador?.doc?.message && (
      <p className="text-red-300 text-sm mt-1">
        {errors.comprador.doc.message}
      </p>
    )}
  </div>
</section>

    <button
      type="submit"
      onClick={onClick}
      className='btn'
    >
      Siguiente
    </button>
  </>
  );
}
